import {Interpolation} from 'styled-components';

import {DEFAULT_PALETTE} from './defaultPalette';

enum EControl {
  default,
  focus,
  hover,
  disabled,
  invalid,
  readOnly,
}
type TControl = keyof typeof EControl;
export type TControlColors = Record<TControl, Interpolation<object>>;

const TRANSPARENT_BORDER = 'border-color:transparent;';

const DEFAULT_CONTROL_COLORS: TControlColors = {
  default: `${TRANSPARENT_BORDER}background-color:${DEFAULT_PALETTE.grey50};`,
  focus: `border-color:${DEFAULT_PALETTE.grey900};`,
  hover: '',
  disabled: `${TRANSPARENT_BORDER}background-color:${DEFAULT_PALETTE.grey50};color:${DEFAULT_PALETTE.grey600};`,
  invalid: `background-color:${DEFAULT_PALETTE.red100};`,
  readOnly: `${TRANSPARENT_BORDER}background-color:${DEFAULT_PALETTE.grey10};`,
};

export const createControlColors = (
  customControlColors?: Partial<TControlColors>,
): TControlColors => ({
  ...DEFAULT_CONTROL_COLORS,
  ...customControlColors,
});
